export default __webpack_public_path__ + "static/media/user.e7996d7c.jpg";